import { Button } from "antd";

import { ServiceCategoryCards } from "features/serviceCategory/ui/ServiceCategoryCards";
import ServiceCategoryFormModal from "features/serviceCategory/ui/ServiceCategoryFormModal";
import { ServiceCategoryViewModal } from "features/serviceCategory/ui/ServiceCategoryViewModal";
import {
  ServiceCategory,
  ServiceCategorySection as CategorySection,
} from "features/serviceCategory/model/serviceCategory";
import { ServiceCategorySectionTabs } from "./ServiceCategorySectionTabs";
import { useServiceCategorySection } from "./useServiceCategorySection";

type Props = {
  section: ReturnType<typeof useServiceCategorySection>;
  pagination: { current: number; pageSize: number; total: number };
  onPageChange: (page: number, pageSize: number) => void;
  /** Навигация по дереву категорий. */
  level: number;
  ancestorId: number | null;
  canGoUp: boolean;
  onOpenCategory: (row: ServiceCategory) => void;
  onGoToParent: () => void;
  onGoToRoot: () => void;
  onSectionChange: (section: CategorySection) => void;
};

export const ServiceCategorySection = ({
  section,
  pagination,
  onPageChange,
  level,
  ancestorId,
  canGoUp,
  onOpenCategory,
  onGoToParent,
  onGoToRoot,
  onSectionChange,
}: Props) => (
  <>
    <ServiceCategorySectionTabs
      value={section.section}
      onChange={onSectionChange}
    />

    <div
      style={{
        display: "flex",
        gap: 10,
        alignItems: "center",
        marginBottom: 12,
      }}
    >
      <Button onClick={onGoToParent} disabled={!canGoUp}>
        Назад
      </Button>
      <Button onClick={onGoToRoot} disabled={!canGoUp}>
        В корень
      </Button>
      <div style={{ opacity: 0.7 }}>
        Level: {level} {ancestorId != null ? `| ancestorId: ${ancestorId}` : ""}
      </div>
    </div>

    <ServiceCategoryViewModal
      open={section.viewOpen}
      row={section.viewRow}
      onClose={section.closeView}
      title="Категория услуги"
    />

    <ServiceCategoryFormModal
      open={section.editOpen}
      loading={section.isSaving}
      initial={section.editingRow}
      defaultSection={section.section}
      onCancel={section.closeEdit}
      onSubmit={section.handleSubmit}
    />

    <ServiceCategoryCards
      data={section.cards}
      isFetching={section.isFetching}
      pagination={{ ...pagination, total: section.cardsTotal }}
      onPageChange={onPageChange}
      onOpen={onOpenCategory}
      onView={section.openView}
      onEdit={section.openEdit}
      onDelete={section.handleDelete}
    />
  </>
);
